export type CreditCardPaymentTypeSource = {
  creditCardPaymentType?: string | null;
  paymentType?: string | null;
  paymentTypeName?: string | null;
};

export function creditCardPaymentTypeLabel(
  payment: CreditCardPaymentTypeSource | null | undefined
): string {
  return (
    payment?.creditCardPaymentType?.trim() ||
    payment?.paymentTypeName?.trim() ||
    payment?.paymentType?.trim() ||
    ''
  );
}

export function subscriberPendingFeeIdLabel(
  subscriberPendingFeeId: number | null | undefined
): string {
  if (subscriberPendingFeeId == null) return '';
  return String(subscriberPendingFeeId);
}
